<template>
  <artmisads-modal
    v-model:open="visible"
    title="Bulk Update"
    :width="1200"
    :destroyOnClose="false"
    :maskClosable="false"
    :footer="null"
    :onCancel="onCancelClose"
  >
    <div>
      <exampleTable
        v-if="showExample"
        :setDataList="setDataList"
        :dataList="dataList"
        :setShowExample="setShowExample"
      />
      <failSuccessList
        v-else
        :dataList="dataList"
        :showExample="showExample"
        :setDataList="setDataList"
        :setShowUpdateProductModal="setShowUpdateProductModal"
        :getProductList="getProductList"
        :setShowExample="setShowExample"
        :onCancel="onCancel"
      />
    </div>
  </artmisads-modal>
</template>
<script setup lang="jsx">
import { ref, defineEmits, defineExpose } from 'vue'
import exampleTable from './exampleTableAiList.vue'
import failSuccessList from './failSuccessListAiList.vue'
import { Modal } from 'ant-design-vue'
const visible = ref(false)
const showExample = ref(true)

const showUpdateProductModal = ref(false)
const emits = defineEmits(['refreshList'])
const open = () => {
  showExample.value = true
  visible.value = true
}
const dataList = ref({
  failList: [],
  successList: [],
})
const setDataList = (data) => {
  dataList.value = data
}
const setShowUpdateProductModal = (status) => {
  showUpdateProductModal.value = status
}

const setShowExample = (status) => {
  showExample.value = status
}


const getProductList = () => {
  emits('refreshList')
  visible.value = false
}
const onCancel = () => {
 showUpdateProductModal.value = false
  dataList.value = {
    failList: [],
    successList: [],
  }
  showExample.value = true
  visible.value = false
}
const onCancelClose = () => {
  showUpdateProductModal.value = false
  dataList.value = {
    failList: [],
    successList: [],
  }
  showExample.value = true

}
// 暴露方法给父组件
defineExpose({
  open,
})
</script>
